import { createSvgIcon } from "@mui/material/utils";

/**
 * The approved outline thumbs-up (the mockup's Like glyph). The Rounded set ships
 * only a filled thumb, so the at-rest Like uses this outline and the liked state
 * keeps ThumbUpAltRounded.
 */
export const ThumbUpOutlineIcon = createSvgIcon(
  <path d="M21 8h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.59 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-2c0-1.1-.9-2-2-2m0 4-3 7H9V9l4.34-4.34L12.23 10H21zM1 9h4v12H1z" />,
  "ThumbUpOutline",
);
